import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Configurator from "@/components/Configurator";
import AdminDashboard from "@/components/AdminDashboard";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Configurator />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
